<div class="map-wrapper" aria-hidden="true" #mapWrapper>
  <div #toposmapcontainer id="toposmap" class="map"></div>
  <app-search-info-mobile></app-search-info-mobile>
</div>